import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'pages',
    canMatch: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () => import('./pages/pages.component'),
    children: [
      {
        path: 'hashtag',
        title: 'Hashtag',
        loadComponent: () => import('./pages/hashtag/hashtag.component'),
      },
      {
        path: 'sentiment',
        title: 'Sentiment',
        loadComponent: () => import('./pages/sentiment/sentiment.component'),
      },
      {
        path: 'post',
        title: 'Post',
        loadComponent: () => import('./pages/post/post.component'),
      },
      {
        path: 'announcement',
        title: 'Announcement',
        loadComponent: () => import('./pages/announcement/announcement.component'),
      },
      {
        path: 'present',
        title: 'Present',
        loadComponent: () => import('./pages/present/present.component'),
      },
      {
        path: 'user/user',
        title: 'User',
        loadComponent: () => import('./pages/user/user/user.component'),
      },
      {
        path: 'user/identification',
        title: 'User',
        loadComponent: () => import('./pages/user/user-identification/user-identification.component'),
      },
      {
        path: 'notification/automatic',
        title: 'Notification',
        loadComponent: () => import('./pages/notification/automatic-notification/automatic-notification.component'),
      },
      {
        path: 'notification/manual',
        title: 'Notification',
        loadComponent: () => import('./pages/notification/manual-notification/manual-notification.component'),
      },
      {
        path: 'policy',
        title: 'Policy',
        loadComponent: () => import('./pages/policy/policy.component'),
      },
      {
        path: '', redirectTo: 'hashtag', pathMatch: 'full',
      }
    ]
  },
  {
    path: 'login',
    title: 'Login',
    loadComponent: () => import('./pages/login/login.component'),
  },
  {
    path: 'register',
    title: 'Register',
    loadComponent: () => import('./pages/register/register.component'),
  },
  {
    path: '**',
    redirectTo: 'pages',
    pathMatch: 'full'
  }
];
